module.exports = __webpack_public_path__ + "ffea60bf3178bec599baba7ad2ea3229.mp4";